import { brandCss } from "@cafe/shared";
import { useEffect } from "react";
import { useMe } from "@/shared/hooks/session";

/** Свой бренд (`addon.white_label`) из /me или null — тогда Coca. */
export function useBrand() {
  return useMe().data?.company.brand ?? null;
}

/** Название системы в заголовке вкладки: свой бренд или Coca. */
export function useBrandName() {
  return useBrand()?.name ?? "Coca";
}

/** Цвет бренда поверх темы: `<style>` с токенами `--primary*`; без бренда или после выхода — снимается. */
export function BrandTheme() {
  const color = useBrand()?.color ?? null;
  useEffect(() => {
    const css = brandCss(color);
    if (!css) return;
    const el = document.createElement("style");
    el.id = "cafe-brand";
    el.textContent = css;
    document.head.appendChild(el);
    return () => el.remove();
  }, [color]);
  return null;
}
